<button [color]="color" mat-icon-button>
  <ng-content></ng-content>
</button>